// Module
var code = `<ol class="deck-phases">
  {{#phases}}
  <li class="deck-phase deck-phase--{{attrStatus}}">
    <div class="deck-phase-card">
      <p class="deck-phase-title">{{title}}</p>
      <p class="deck-phase-copy">{{copy}}</p>
    </div>
    <p class="deck-phase-pill">{{period}}</p>
  </li>
  {{/phases}}
</ol>
{{#eraNotes}}
<p class="deck-era-note">{{copy}}</p>
{{/eraNotes}}
`;
// Exports
module.exports = code;